if (!customElements.get('bottom-sticky-bar')) {
  customElements.define(
    'bottom-sticky-bar',
    class BottomStickyBar extends HTMLElement {
      constructor() {
        super();
        window.addEventListener('scroll', this.handleScroll.bind(this), false);
      }

      handleScroll(_) {
        const CHANGE_POINT = window.outerHeight - 400;

        if (window.scrollY > CHANGE_POINT) {
          this.classList.add('product-bottom-sticky-bar--visible');
        } else {
          this.classList.remove('product-bottom-sticky-bar--visible');
        }
      }
    }
  );
}
